export enum VIDEO_FORMATS {
  mp4 = 'video/mp4',
  mov = 'video/quicktime',
}

export const VALID_FORMATS: string[] = [VIDEO_FORMATS.mp4, VIDEO_FORMATS.mov];
export const VALID_MAX_SIZE: number = 3 * 1000 * 1000 * 1000;
